import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ChatUIState {
  isOpen: boolean;
  /** User dismissed the floating bubble — hides it until reopened from a menu. */
  bubbleHidden: boolean;
  open: () => void;
  close: () => void;
  hideBubble: () => void;
}

/**
 * UI state for "Fråga Erik". Two states the customer cares about:
 * - `isOpen`: the full chat panel is open
 * - `bubbleHidden`: the tiny floating "Fråga Erik" button is dismissed
 *
 * Persisted so the dismissal sticks across page loads. Opening the chat from
 * any entry point (menu, footer) clears the dismissal so the bubble is
 * available again.
 */
export const useChatUI = create<ChatUIState>()(
  persist(
    (set) => ({
      isOpen: false,
      bubbleHidden: false,

      open: () => set({ isOpen: true, bubbleHidden: false }),
      close: () => set({ isOpen: false }),
      hideBubble: () => set({ bubbleHidden: true }),
    }),
    {
      name: 'autofrance-chat-ui',
      // Only persist bubbleHidden — isOpen should reset between sessions
      partialize: (state) => ({ bubbleHidden: state.bubbleHidden }) as Partial<ChatUIState>,
    }
  )
);
